import { HiChevronDoubleRight } from "react-icons/hi"; 
import { BiLockOpenAlt } from "react-icons/bi"; 
import { BiLockAlt } from "react-icons/bi"; 
import React from 'react';
import { useTranslation } from '../../hx/useTranslation';
import * as FxLog from '../../fx/FxLog';
import GxList from '../../gx/GxList';
import GxPrint from '../../gx/GxPrint';
import CxDlgAlert from '../../cx/CxDlgAlert';
import { useWindowSize } from '../../hx/useWindowSize';
import * as FxTable from '../../fx/FxTable';
import * as FxFetch from '../../fx/FxFetch';
import * as FxRegion from '../../fx/FxRegion';
import CxSnackbar from '../../cx/CxSnackbar';
import { clearStore, getStoreValue, StoreSlsLst, StoreSlsDoc, StoreMassBilling, } from "../../gx/GxStore";
import { useSessionStorage } from '../../hx/useSessionStorage';
import CxIconButton from '../../cx/CxIconButton';
import CxIconButtonNew from '../../cx/CxIconButtonNew';
import { useNav } from '../../hx/useNav';
import * as MxSlsDocFormH1 from './MxSlsDocFormH1';


const MxMassBillingList = (props) => {
  const [{ trans }] = useTranslation();
  const [{ navTo, navStackRemove }] = useNav();
  const size = useWindowSize();

  const [storeSlsLst, setStoreSlsLst] = useSessionStorage('StoreSlsLst', StoreSlsLst);
  const [storeSlsDoc, setStoreSlsDoc] = useSessionStorage('StoreSlsDoc', StoreSlsDoc);

  const [isVerifactu,] = React.useState(getStoreValue('StoreSession', 'txERec')==='VF');
  
  const r_list = React.useRef(null);
  let r_print = React.useRef(null);

  const r_snack_success = React.useRef(null);
  const r_snack_error = React.useRef(null);
  const r_dlg_alert = React.useRef(null);

  // eslint-disable-next-line
  const [storeMassBilling, setStoreMassBilling] = useSessionStorage('StoreMassBilling', StoreMassBilling);

  //const [lockIssue, setLockIssue] = React.useState(true);
  const [lockExclude, setLockExclude] = React.useState(true);


  React.useEffect(() => {
    // 2025-05-12 - daq: si viene de factura, para hacer una rectificativa, hacemos que si vuelve lo haga al listado de facturas.
    navStackRemove('sls-doc-form');

    // eslint-disable-next-line
  }, []);

  /* // 2025-05-21 - daq: ahora se hace editando el albarán
  const doIssueDoc = (row) => {
    try {
      let record = {};
      record['inInvoice'] = row.inInvoice;
      record['itSeries'] = row._itSeries;
      record['dtReceipt'] = row.dtInvoice;
      Promise.all([FxFetch.doJsonX(`sls/doc/issue_receipt_from_invoice`, record)]).then((result) => {
        r_list.current.refresh();
      });

      r_snack_success.current.setOpen(true);

    } catch (error) {
      FxLog.errorx("MxMassBillingList.doIssueDoc", error);
    }
  }
  */

  const openForm = async (op, row) => {
    FxLog.infox('MxSlsReceiptInvoicesList.openForm', '...row.original.inInvoice:', row.original.inInvoice);
    clearStore('StoreSlsLst', storeSlsLst);
    storeSlsLst.listType = 'i';
    storeSlsLst.listTypeBackground = 'var(--ibs_color_blue_light)';
    storeSlsLst.table = 'n_invoice';
    storeSlsLst.table_idField = 'inInvoice';
    storeSlsLst.table_txField = 'txInvoice';
    storeSlsLst.table_dtField = 'dtInvoice';
    storeSlsLst.table_item = 'n_invoice_item';
    storeSlsLst.table_item_idField = 'inInvoiceItem';
    storeSlsLst.table_paym_idField = 'inPayment';
    setStoreSlsLst(storeSlsLst);

    clearStore('StoreSlsDoc', storeSlsDoc);
    storeSlsDoc.boFirstRender = true;
    storeSlsDoc.boDataChanged = '0';
    storeSlsDoc.docType = 'i';
    storeSlsDoc.inXXX = row.original.inInvoice;
    storeSlsDoc.boUpdateDelete = true;
    Promise.all([MxSlsDocFormH1.load(storeSlsLst, storeSlsDoc)]).then((result) => {
      setStoreSlsDoc(storeSlsDoc);
      navTo("sls-doc-form");
    });
  }

/* 
  const doPrintX = async (op, row) => {
    let filter = {};
    filter['reportFormat'] = `PDF`;
    filter['inClient'] = row.original.inClient;
    filter['inXXX'] = row.original.inInvoice;
    filter['docType'] = 'i';
    filter['docSize'] = size.isLarge ? 'A4' : 'A8';
    filter['salesSlipWidth'] = localStorage.getItem('MxSettSlsPrinting.sales_slip_width') || '60';
    filter['salesSlipMarginLeft'] = localStorage.getItem('MxSettSlsPrinting.sales_slip_margin_left') || '0';
    let record = {};
    if (filter['docSize'] === 'A8') {
      r_print.current.setScale(1.8);
    }
    if (filter['docSize'] === 'A4') {
      r_print.current.setScale(1.5);
    }
    r_print.current.setUrl('slsDoc/report');
    //----------------
    Promise.all([
      r_print.current.setFilter(filter),
      r_print.current.setRecord(record),
      r_print.current.setInClient(row.original.inClient),
    ]).then((result) => {
      r_print.current.doPrint();
    });
  }
 */

  const doExcludeInvoice = (row) => {
    let inInvoice = row.inInvoice;
    storeMassBilling.arExcludedId += "|" + inInvoice;
    Promise.all([setStoreMassBilling(storeMassBilling)]).then((result) => {
      Promise.all([r_list.current.setdeepAddParams(getAddParams())]).then((result) => {
        r_list.current.refresh();
      });
    });
  }

  const goNext = async () => {
    r_dlg_alert.current.setOpen(true);
    Promise.all([setListedId()]).then((result) => {
      r_dlg_alert.current.setOpen(false);
      navTo("mass-billing-option");
    });
  }

  const setListedId = () => {
    let record = {};
    record['pageNo'] = '0';
    record['pageSize'] = '1000';
    record['sortBy'] = '';
    record['filter'] = '';
    record['group'] = '';
    let addParams = getAddParams();
    if (addParams) {
      let params = addParams.split("&");
      params.forEach(function (item, index) {
        record[item.split("=")[0]] = item.split("=")[1];
      });
    }
    return Promise.all([FxFetch.doJsonX("mass_billing", record)]).then((result) => {
      let rs = result[0];
      let all = '';
      if (rs) {
        for (let i = 0; i < rs.length; i++) {
          if (!isVerifactu || (FxRegion.isValidSpanishID(rs[i].txIc) || rs[i].txClient.length===0)) {
            all += "|" + rs[i].inInvoice + "-" + (rs[i].inClient || '');
          }
        }
        storeMassBilling.arListedId = all;
        return Promise.all([setStoreMassBilling(storeMassBilling)]).then((result) => {
          return;
        });
      }
    });
  }

  const getTableColumns = () => {
    let cols = [];
    let id = -1;
    cols.push({ id: id++, Header: "ID", accessor: "inInvoice", show: false });
    if (size.isLarge) { // PANTALLA GRANDE
      cols.push({ id: id++, Header: trans('field.doc'), accessor: "txInvoice", width: '10%' });
      cols.push({ id: id++, Header: trans('field.date'), accessor: row => FxTable.cellToLocalDate(row["dtInvoice"]), width: '10%' });
      cols.push({ id: id++, Header: "_itSeries", accessor: "itSeries", show: false });
      cols.push({ id: id++, Header: "_inClient", accessor: "inClient", show: false });
      cols.push({ id: id++, Header: trans('field.client'), accessor: "txClient", width: '20%' });
      cols.push({ id: id++, Header: trans('field.insurance'), accessor: "txTypeInsurPlan", show: false });

      cols.push({ id: id++, Header: trans("field.taxable") + "-1", accessor: row => (FxTable.cellTo2r00(row["nuTaxable1"])), align: 'right', show: false });
      cols.push({ id: id++, Header: trans("field.taxable") + "-2", accessor: row => (FxTable.cellTo2r00(row["nuTaxable2"])), align: 'right', show: false });
      cols.push({ id: id++, Header: trans("field.taxable") + "-3", accessor: row => (FxTable.cellTo2r00(row["nuTaxable3"])), align: 'right', show: false });
      cols.push({ id: id++, Header: trans("field.taxable") + "-4", accessor: row => (FxTable.cellTo2r00(row["nuTaxable4"])), align: 'right', show: false });
      cols.push({ id: id++, Header: trans("field.taxable") + "-5", accessor: row => (FxTable.cellTo2r00(row["nuTaxable5"])), align: 'right', show: false });
      cols.push({ id: id++, Header: trans("field.tax_perc") + "-1", accessor: row => (FxTable.cellTo2r00(row["nuTaxPerc1"])), align: 'right', show: false });
      cols.push({ id: id++, Header: trans("field.tax_perc") + "-2", accessor: row => (FxTable.cellTo2r00(row["nuTaxPerc2"])), align: 'right', show: false });
      cols.push({ id: id++, Header: trans("field.tax_perc") + "-3", accessor: row => (FxTable.cellTo2r00(row["nuTaxPerc3"])), align: 'right', show: false });
      cols.push({ id: id++, Header: trans("field.tax_perc") + "-4", accessor: row => (FxTable.cellTo2r00(row["nuTaxPerc4"])), align: 'right', show: false });
      cols.push({ id: id++, Header: trans("field.tax_perc") + "-5", accessor: row => (FxTable.cellTo2r00(row["nuTaxPerc5"])), align: 'right', show: false });
      cols.push({ id: id++, Header: trans("field.tax") + "-1", accessor: row => (FxTable.cellTo2r00(row["nuTax1"])), align: 'right', show: false });
      cols.push({ id: id++, Header: trans("field.tax") + "-2", accessor: row => (FxTable.cellTo2r00(row["nuTax2"])), align: 'right', show: false });
      cols.push({ id: id++, Header: trans("field.tax") + "-3", accessor: row => (FxTable.cellTo2r00(row["nuTax3"])), align: 'right', show: false });
      cols.push({ id: id++, Header: trans("field.tax") + "-4", accessor: row => (FxTable.cellTo2r00(row["nuTax4"])), align: 'right', show: false });
      cols.push({ id: id++, Header: trans("field.tax") + "-5", accessor: row => (FxTable.cellTo2r00(row["nuTax5"])), align: 'right', show: false });

      cols.push({ id: id++, Header: trans("field.taxable"), accessor: row => (FxTable.cellTo2r00(row["nuTotalTaxable"])), width: '10%', align: 'right' });
      cols.push({ id: id++, Header: trans("field.discount"), accessor: row => (FxTable.cellTo2r00(row["nuTotalDiscount"])), width: '10%', align: 'right' });
      cols.push({ id: id++, Header: trans("field.tax"), accessor: row => (FxTable.cellTo2r00(row["nuTotalTax"])), width: '10%', align: 'right' });
      cols.push({ id: id++, Header: trans("field.amount"), accessor: row => (FxTable.cellTo2r00(row["nuTotalAmount"])), align: 'right', show: false });
      cols.push({ id: id++, Header: trans("field.wtax_s"), accessor: row => (FxTable.cellTo2r00(row["nuTotalWtax"])), align: 'right', show: false });
      cols.push({ id: id++, Header: trans("field.total"), accessor: row => (FxTable.cellTo2r00(row["nuTotalFinal"])), width: '10%', align: 'right' });
      cols.push({ id: id++, Header: trans("field.paid"), accessor: row => (FxTable.cellTo2r00(row["nuTotalPayment"])), width: '10%', align: 'right' });
      cols.push({ id: id++, Header: trans('field.type_payment'), accessor: row => row["txTypePayment"], width: '10%', align: 'left' });
      cols.push({ id: id++, Header: trans("field.balance"), accessor: row => (FxTable.cellTo2r00(row["theBalance"])), align: 'right', show: false });

      cols.push({ id: id++, Header: trans('field.notes'), accessor: "txNotes", show: false });

      cols.push({ id: "R", Header: "balance", accessor: row => Boolean((row["theBalance"]) < 0 ? true : false), show: false });

    } else { // PANTALLA PEQUEÑA
      cols.push({ id: id++, Header: trans('field.doc'), accessor: "txInvoice", width: '30%' });
      cols.push({ id: id++, Header: trans('field.date'), accessor: row => FxTable.cellToLocalDate(row["dtInvoice"]), width: '30%' });
      cols.push({ id: id++, Header: "_itSeries", accessor: "itSeries", show: false });
      cols.push({ id: id++, Header: trans("field.total"), accessor: row => (FxTable.cellTo2r00(row["nuTotalFinal"])), width: '20%', align: 'right' });

      cols.push({ id: "R", Header: "balance", accessor: row => Boolean((row["theBalance"]) < 0 ? true : false), show: false });
    }

    if (isVerifactu) {
      cols.push({ id: 'W', Header: "VerifactuNifIncorrecto", accessor: row => Boolean(!FxRegion.isValidSpanishID(row["txIc"]) && row["txClient"]), show: false });
    }

    /*
    cols.push({
      id: "BTN_I11", icon: <BiLockAlt />, icon_alt: <BiLockOpenAlt />, iconTooltip: trans('field.column_lock_unlock'), onIconClick: () => setLockIssue(!lockIssue),
      accessor: row => { return <CxIconButton type="check" classType="ibs_iconbutton_table_body" disabled={lockIssue} data={row} onClick={doIssueDoc} tooltip={trans("field.issue_x", 'field.receipt')} /> },
      align: 'center', width: '33px'
    });
    */
    cols.push({
      id: "BTN_EXC", icon: <BiLockAlt />, icon_alt: <BiLockOpenAlt />, iconTooltip: trans('field.column_lock_unlock'), onIconClick: () => setLockExclude(!lockExclude),
      accessor: row => { return <CxIconButton type="cancel" classType="ibs_iconbutton_table_body" disabled={lockExclude} data={row} onClick={doExcludeInvoice} tooltip={trans("field.exclude_from_x", 'field.list')} /> },
      align: 'center', width: '33px'
    });

    return cols;
  }

  const getAddParams = () => {
    return "dtInvoiceFrom=" + storeMassBilling.dtInvoiceFrom + ""
      + "&dtInvoiceTo=" + storeMassBilling.dtInvoiceTo + ""
      + "&inClient=" + storeMassBilling.inClient + ""
      + "&inEmployee=" + storeMassBilling.inEmployee + ""
      + "&inBranch=" + storeMassBilling.inBranch + ""
      + "&txInvoice=" + storeMassBilling.txInvoice + ""
      + "&nuTotalFinalFrom=" + storeMassBilling.nuTotalFinalFrom + ""
      + "&nuTotalFinalTo=" + storeMassBilling.nuTotalFinalTo + ""
      + "&nuTotalTaxFrom=" + storeMassBilling.nuTotalTaxFrom + ""
      + "&nuTotalTaxTo=" + storeMassBilling.nuTotalTaxTo + ""
      + "&boPaid=" + storeMassBilling.boPaid + ""
      + "&arPayments=" + storeMassBilling.arPayments + ""
      + "&arSeries=" + storeMassBilling.arSeries + ""
      + "&arCash=" + storeMassBilling.arCash + ""
      + "&arExcludedId=" + storeMassBilling.arExcludedId + "";
  }

  return (
    <div>
      <GxList
        moduleName={`${trans('field.mass_billing')}: ${trans('field.list')}`}
        xref={r_list}
        fullscreen
        hasSearchBox={false}
        hasButtonAdd={false}
        url="mass_billing"
        addParams={getAddParams()}
        onOpenForm={openForm/* doPrintX */}
        refColors={isVerifactu ?
          ['table_cell_color_red|' + trans('field.debtor'), `table_cell_color_brown|Verifactu - NIF Incorrecto`]
          :
          ['table_cell_color_red|' + trans('field.debtor')]
        }
        columns={getTableColumns()}
        addToolbarButtons={
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <CxIconButtonNew icon={<HiChevronDoubleRight fontSize={23} />} classType="ibs_iconbutton_toolbar" onClick={goNext} tooltip={trans('field.next')} />
          </div>
        }
      >
      </GxList>

      <CxDlgAlert xref={r_dlg_alert} />
      <GxPrint xref={r_print} />

      <CxSnackbar xref={r_snack_success} severity="success" value={trans('msg.operation_successful')} />
      <CxSnackbar xref={r_snack_error} severity="error" />

    </div>
  );

}

export default MxMassBillingList;
